import { useNavigate } from "react-router-dom";

import { useTranslate } from "@/providers/context";
import { Button } from "./Button";

export const SubscribeButton = () => {
  const navigate = useNavigate();
  const { translate } = useTranslate();

  return (
    <Button size="m" onClick={() => navigate("/for-sale")}>
      {translate("Subscribe")}
    </Button>
  );
};
